import { IGroupConfigurationData, IPharmacyORE } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";


export class PharmacyResetTransformer extends BaseJsonTransformer {

    constructor() {
        super();
    }

    async after(json: IGroupConfigurationData): Promise<void> {

        if (!json?.pharmacyORE)
            json.pharmacyORE = [];

        json.pharmacyORE = json?.pharmacyORE?.map((existing) => {
            const newObj: IPharmacyORE =
            {
                id: existing.id,
                pharmacyPlanDesign: existing.newPharmacyPlanDesign
                    ? existing.newPharmacyPlanDesign
                    : existing.pharmacyPlanDesign,
                newPharmacyPlanDesign: "",
                newClientNumber: "",
                releaseStatus: "In Progress"
            };
            return newObj;
        });

        // TODO move this to removeDeactivatedData transformer
        if (json?.comments?.length > 0)
            json.comments = [];
    }

}
